import type { Branded } from '@/utils/typing/branded.type';

export type SessionId = Branded<string, 'SessionId'>;

export function sessionId(sessionId: string): SessionId {
    return sessionId as SessionId;
}

export function generateSessionId(): SessionId {
    return crypto.randomUUID() as SessionId;
}
